import Head from 'next/head';
import { useRouter } from 'next/router';
import Layout from 'components/layout';
import MobileButton from 'components/button';
import style from 'styles/news/index.module.scss';
import React, { useRef, useState } from 'react';
import { GetStaticProps } from 'next';
import Loading from 'components/loading';
import { Pagination, List } from 'antd';
//import { pageSize } from 'constants/index';
import { action, actionServer } from 'action/index';
import Banner from 'components/banner';
import cn from 'classnames';
const pcBanner = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/news/pc/pc-company-dynamic-title.jpg';
const mobileBanner = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/news/mobile/m-company-dynamic-title.jpg';
const pageSize = 20;
interface INews {
  id: string;
  newsTitle: string;
  newsSummary: string;
  newsCover: string;
  newsAuthor: string;
  releaseTime: string;
}

interface IProps {
  list: INews[];
  current: number;
  total: number;
}

export default function Home(props: IProps) {
  const { list, current, total } = props;

  const router = useRouter();

  if (router.isFallback) {
    return <Loading />;
  }

  return (
    <Layout>
      <Head>
        <title>新闻中心 - 小鱼易连-官网-让世界零距离</title>
      </Head>
      <section className={style.container}>
        <Banner bgImage={pcBanner} bgImageMobile={mobileBanner} title="公司新闻" />
        <div className={style.body}>
          <MobileList list={list} total={total} current={current} />
          <PcList list={list} total={total} current={current} />
        </div>
      </section>
    </Layout>
  );
}

interface INewsListProps {
  list: INews[];
  current: number;
  total: number;
}

const Item = (item: INews) => {
  const router = useRouter();
  const onViewInfo = () => {
    router.push(`/news/${item.id}`);
  };
  const newsAuthor = item.newsAuthor && item.newsAuthor.length > 10 ? `${item.newsAuthor.substring(0, 10)}...` : item.newsAuthor;
  return (
    <div className={style.newsItem} key={item.id} onClick={onViewInfo}>
      <div className={style.logo}>
        <img src={item.newsCover} alt={item.newsTitle} />
      </div>
      <div className={style.content}>
        <div>
          <div className={style.title}>{item.newsTitle}</div>
          <div className={cn(style.desc, 'for-pc')}>{item.newsSummary}</div>
        </div>
        <div className={style.date}>
          <span>{item.releaseTime}</span>
          {newsAuthor && <span className={cn(style.author, 'for-pc')}>发布者：{newsAuthor}</span>}
        </div>
      </div>
    </div>
  );
};

const PcList = (props: INewsListProps) => {
  const { list, current, total: newsTotal } = props;
  const [newsList, setNewsList] = useState(list);
  const [total, setTotal] = useState(newsTotal);

  const onChangePage = async (page: number) => {
    const res = await action.getNewsList(page, pageSize);

    if (res) {
      const { total, records } = res;
      setNewsList(records);
      setTotal(total);
    }
  };
  return (
    <div className={cn(style.pcWrapper, style['for-pc'])}>
      <div className={style.newsList}>
        {newsList.map(item => {
          return <Item {...item} key={item.id} />;
        })}
      </div>
      {total > pageSize && <Pagination showLessItems={true} className={style.pagination} total={total} defaultCurrent={current} showSizeChanger={false} pageSize={pageSize} onChange={onChangePage} />}
    </div>
  );
};

const MobileList = (props: INewsListProps) => {
  const { list, current, total: newsTotal } = props;
  const [newsList, setNewsList] = useState(list);
  const [total, setTotal] = useState(newsTotal);
  // 移动端
  const [loading, setLoading] = useState(false);
  const page = useRef(current);

  const onLoadMore = async () => {
    setLoading(true);
    page.current += 1;
    const res = await action.getNewsList(page.current, pageSize);
    if (res) {
      const { total, records } = res;
      setTotal(total);
      setNewsList((list: any) => [...list, ...records]);
    }
    setLoading(false);
  };
  return (
    <List
      className={cn(style.newsList, style['for-mobile'])}
      // loading={initLoading}
      itemLayout="horizontal"
      loadMore={
        total > newsList.length && (
          <MobileButton category="viewMore" className={style.loadMore} onClick={onLoadMore} loading={loading}>
            查看更多...
          </MobileButton>
        )
      }
      dataSource={newsList}
      renderItem={(item: INews) => <Item {...item} key={item.id} />}
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await actionServer.getNewsList(1, pageSize);
  const fallback = {
    list: res?.records ?? [],
    total: res?.total || 0,
    current: 1,
  };

  return {
    props: {
      ...fallback,
    },
    revalidate: 30,
  };
};
